export enum ContentTypeCodenames {
    AboutUsTimeline = "about_us_timeline",
    AddedProtectionSection = "added_protection_section",
    Alert = "alert",
    ArticleListingPage = "blog_index",
    ArticlePage = "blog_post",
    ArticlePageConfig = "article_page_config",
    AuthorProfile = "author_profile",
    BestArticleListingPage = "best_article_listing_page",
    CampaignTile = "campaign_tile",
    ConfirmModal = "confirm_modal",
    CookieSettingsWidget = "cookie_settings_widget",
    ContactFormPage = "contact_page",
    ContentCallout = "content_callout",
    ContentCardList = "content_card_list",
    ContentCardRow = "content_card_row",
    CustomerCarePage = "customer_care_page",
    CustomSignUpBlock = "custom_sign_up_block",
    ContentImageCard = "content_image_card",
    ContentVideoCard = "content_video_card",
    CustomTable = "custom_table",
    DynamicPhoneNumber = "dynamic_phone_number",
    DynamicSidebar = "dynamic_sidebar",
    EventBlock = "event_block",
    EventsArticleListingPage = "events_article_listing_page",
    FAQ = "faq",
    Feature = "feature",
    FeatureLink = "feature_link",
    FooterLegalMenu = "footer_legal_menu",
    FooterMainImage = "footer_main_image",
    FooterMainTitle = "footer_main_title",
    FooterMenu = "footer_menu",
    FooterMenuLinksList = "footer_menu_links_list",
    FooterSignupSection = "footer_signup_section",
    FooterSocialMedia = "footer_social_media",
    FooterSocialText = "footer_social_text",
    FooterText = "footer_text",
    GuidesArticleListingPage = "guides_article_listing_page",
    HeaderMainMenu = "header_main_menu",
    HeaderMegaMenu = "header_mega_menu",
    HeaderMegaMenuBannersItem = "header_mega_menu__banners_item",
    HeaderMegaMenuItem = "header_mega_menu_item",
    HeaderMegaMenuLinksItem = "header_mega_menu__links_item",
    HeaderMenuLink = "header_menu_link",
    HeaderMobilePromoItem = "header_mobile_promo_item",
    HeaderNavMenu = "header_nav_menu",
    HeaderPhoneNumber = "header_phone_number",
    HeaderPromo = "header_promo",
    HeaderRotatingBanner = "header_rotating_banner",
    HeroTextImage = "hero_text_image",
    HomePageCampaignRow = "home_page_campaign_row",
    HomePageContentRow = "home_page_content_row",
    HomePageContentSection = "home_page_content_section",
    HomePageHero = "home_page_hero",
    HomePageHeroBanner = "home_page_hero_banner",
    HomePageFinanceExampleRow = "home_page_finance_example_row",
    HomePageFlexible = "home_page_flexible_",
    HomePageHeroIsolated = "home_page_hero_isolated",
    HomePageKeyMessagingBanners = "home_page_key_messaging_banners",
    HomePageOptionalExtras = "home_page_optional_extras",
    HomePagePromoStrip = "home_page_promo_strip",
    HomePageSearchMagnet = "home_page_search_magnet",
    HomePageUSPs = "home_page_usps",
    HomePageWidgetRow = "home_page_widget_row",
    HomePageReviewsRow = "home_page_reviews_row",
    IconList = "icon_list",
    Image = "image",
    InvestorAnnouncements = "investor_announcements",
    InlineFrame = "inline_frame",
    KeyMessagingBanner = "key_messaging_banner",
    LegacyLink = "legacy_link",
    Link = "link",
    MediaContacts = "media_contacts",
    MegaMenuPromoItem = "mega_menu_promo_item",
    NearlyNewCarsSection = "nearly_new_cars_section",
    NewsArticleListingPage = "news_article_listing_page",
    Organisation = "organisation",
    Person = "person",
    PRArticleListingPage = "press_release_index",
    PRArticlePage = "press_release",
    PressKit = "press_kit",
    PressReleaseTopic = "press_release_topic",
    PromoText = "promo_text",
    QA = "qa",
    RelatedArticles = "related_articles",
    RelatedArticlesComponent = "related_articles_component",
    ReviewTile = "review_tile",
    RequestComments = "request_comments",
    ReviewsBadges = "reviews_badges",
    ReviewsContent = "reviews_content",
    ReviewsSection = "reviews_section",
    ReviewsService = "reviews_service",
    ReviewsWidget = "reviews_widget",
    RotatingBannerRow = "home_page_value_additions_row",
    SectionFeaturedFigures = "section_featured_figures",
    SectionIconList = "section_icon_list",
    SectionImageGallery = "section_image_gallery",
    SellWidget = "sell_widget",
    SellYourCarDamageCheckPage = "sell_your_car___damage_check_page",
    SellYourCarDamageConfirmPage = "sell_your_car___damage_confirm_page",
    SellYourCarDamageDetailPage = "sell_your_car___damage_detail_page",
    SellYourCarDamageSummaryPage = "sell_your_car___damage_summary_page",
    SellYourCarFeaturesPage = "sell_your_car___features_page",
    SellYourCarFinalValuationPage = "sell_your_car___final_valuation_page",
    SellYourCarQuestionsPage = "sell_your_car___questions_page",
    SellYourCarSummaryPage = "sell_your_car___summary_page",
    SendEmailTo = "send_email_to",
    SharePrice = "share_price",
    ShortlistPage = "shortlist_page",
    SignupSection = "signup_section",
    SocialMediaLink = "social_media_link",
    SponsorshipCard = "sponsorship_card",
    StaticCard = "static_card",
    StaticCardList = "static_card_list",
    StaticPage = "static_page",
    StaticPageSubscribe = "static_page_subscribe",
    StaticPageComponentWrapper = "static_page_component_wrapper",
    SharedShortlistPage = "shared_shortlist_page",
    StockNumberSearch = "stock_number_search",
    StoreWidget = "store_widget",
    Testimonials = "testimonials",
    TextMediaBlock = "text_media_block",
    Topic = "blog_topic",
    VehicleAdvertSection = "vehicle_advert_section",
    VehicleAdvertPdp = "vehicle_advert__pdp_",
    VehicleCardCarousel = "vehicle_card_carousel",
    Video = "video",
    PDPFinanceCalculator = "pdp_finance_calculator",
    PDPFinanceCalculatorSettings = "finance_calculator_settings",
    AccordionGroup = "accordion_group",
    PDPVehicleSummary = "vehicle_advert_vehicle_summary",
    ExtrasRowPDP = "extras_row_component",
    PDPWidgetsRow = "pdp_widgets_row",
    PartExchangeWidget = "part_exchange_widget",
    FindYourFinanceWidget = "find_your_finance_widget",
    WhenCanIGetItWidget = "when_can_i_get_it_pdp_widget",
    PDPVehicleDetailsRow = "pdp_vehicle_details_row",
    PDPVehicleSpecs = "pdp_vehicle_specs",
    VehicleSpec = "vehicle_spec",
    PDPVehicleFiguresRow = "pdp_vehicle_figures_row",
    Site = "site",
    PDPFeatures = "pdp_features",
    PDPStoreLocation = "pdp_store_location",
    PDPQualityRow = "pdp_quality_row",
    PDPQualityWidget = "pdp_quality_widget",
    PDPPromosRow = "pdp_promos_row",
    AlertManagementPage = "alert_management_page",
    FAQPage = "faq_page",
    FAQTopicSection = "faq_topic_section",
    FAQSubSection = "faq_sub_section",
    PDPRecommendedVehicles = "pdp_recommended_vehicles",
    PDPRecentlyViewed = "pdp_recently_viewed",
    ReviewListingPage = "review_listing_page",
    Review = "review",
    ReviewPageConfig = "review_page_config",
    ReviewInteriorPage = "review_interior_page",
    ReviewEnginePage = "review_engine_page",
    ReviewAdditionalPage = "review_additional_page",
    Quotation = "quotation",
    VehicleCardSettings = "vehicle_card_settings",
    Shopfront = "shopfront",
    MarketingCampaign = "marketing_campaign",
    Number = "number",
    HexColour = "hex_colour",
    VehicleDisplaySettings = "vehicle_display_settings",
    PDPListSavingsBanner = "pdp_list_saving_banner",
    VehicleNoLongerAvailablePageTemplate = "vehicle_no_longer_available_page_template",
    PageAnchor = "page_anchor",
    SignUpBlock = "sign_up_block",
    MarketingConsent = "marketing_consent",
    MediaContentTable = "media_content_table",
    MediaContentRow = "media_content_row",
    CopyOnly = "copy_only",
    ComparisonArticleListingPage = "comparison_article_listing_page",
    StaticPageNavigation = "static_page_navigation",
}
